import { toast } from 'sonner';

export async function copyTextToClipboard(text) {
  const value = text == null ? '' : String(text);
  if (!value) {
    throw new Error('Nothing to copy');
  }

  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(textarea);
  if (!copied) {
    throw new Error('Clipboard unavailable');
  }
}

export function toastCopied() {
  toast.success('Copied');
}

export function toastCopyFailed(message = 'Unable to copy') {
  toast.error(message);
}

export function isMaskedPlaceholder(value) {
  if (value == null || value === '') return true;
  const normalized = String(value);
  return normalized.includes('•') || normalized.includes('*') || normalized === '—';
}
